import React, { useEffect, useState } from "react";
import { useLanguage } from '../i18n/translations';

export default function Cookies() {
  const { translate } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if the user has already accepted cookies
    const hasAcceptedCookies = localStorage.getItem("cookiesAccepted");
    if (!hasAcceptedCookies) {
      setIsVisible(true); // Show the popup if not accepted
    }
  }, []);

  const handleAccept = () => {
    // Hide the message and set localStorage
    setIsVisible(false);
    localStorage.setItem("cookiesAccepted", "true");
  };

  const popupStyle = {
    
    boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)", // shadow on top
    transition: "transform 0.3s ease-in-out",
    transform: "translateY(0)",
    animation: "slide-in 0.3s ease-in-out" // replace with your actual animation
  };

  return (
    isVisible && (
      <div   style={popupStyle} className=" z-[20] fixed bottom-0 left-0 right-0 bg-white text-gray-700 p-4 shadow-lg flex flex-row items-center justify-center space-x-4 transition-transform transform translate-y-0 animate-slide-in shadow-top">
        <p className="text-sm mb-3 sm:mb-0  text-center ">
          {translate("This site uses cookies for better functionality.")}
          <a
            href="/politika-privatnosti"
            className="underline ml-1 hover:text-gray-300"
          >
            {translate("Learn more")}
          </a>
        </p>
        <button
          onClick={handleAccept}
          className="bg-brownSkin text-white py-2 px-4 text-sm"
        >
          {translate("OK")}
        </button>
      </div>
    )
  );
}
